/**
 * Backend membership-scoped analytics events from fruitful-all
 * `apps/backend/src/modules/event-tracking/events.ts`
 * (`TrackedMembershipEvent` there).
 *
 * Keep these string values in sync until the backend imports this package.
 */
export enum BackendMembershipEvent {
    MEMBERSHIP_PROFILE_COMPLETED = 'MembershipProfileCompleted',

    GUIDANCE_SESSION_BOOKED = 'GuidanceSessionBooked',
    GUIDANCE_SESSION_BOOKED_VIA_API = 'GuidanceSessionBookedViaApi',
    FIRST_KICKOFF_SESSION_BOOKED = 'FirstKickoffSessionBooked',
    GUIDANCE_SESSION_CANCELED = 'GuidanceSessionCanceled',
    GUIDANCE_SESSION_NO_SHOWED = 'GuidanceSessionNoShowed',

    MONEY_MAP_PUBLISHED_FOR_PREVIEW = 'MoneyMapPublishedForPreview',
    MONEY_MAP_FINALIZED_FOR_ACTION = 'MoneyMapFinalizedForAction',
    MONEY_MAP_EDITED_BY_MEMBER = 'MoneyMapEditedByMember',

    DIRECT_DEPOSIT_POSTED = 'DirectDepositPosted',
    CASH_ACCOUNT_TRANSFER_INITIATED = 'CashAccountTransferInitiated',
    CASH_ACCOUNT_RDFI_TRANSFER_RECEIVED = 'CashAccountRdfiTransferReceived',
    ACH_RETURN = 'AchReturn',

    FIRST_NON_ZERO_PAYMENT = 'FirstNonZeroPayment',

    MEMBER_SUBSCRIPTION_ACTIVATED = 'MemberSubscriptionActivated',
    MEMBER_SIGNUP_COMPLETED = 'MemberSignupCompleted',
    MEMBERSHIP_SUBSCRIPTION_CHANGED = 'MembershipSubscriptionChanged',
    MEMBERSHIP_SUBSCRIPTION_CANCEL_SUBMIT = 'MembershipSubscriptionCancellationSubmitted',
    MEMBERSHIP_SUBSCRIPTION_CANCEL_STOP = 'MembershipSubscriptionCancellationStopped',

    ONBOARDING_FUNNEL_EMPLOYMENT_STATUS_COMPLETED = 'OnboardingFunnel_EmploymentStatusCompleted',
    ONBOARDING_FUNNEL_INSURANCE_COMPLETED = 'OnboardingFunnel_InsuranceCompleted',
    ONBOARDING_FUNNEL_TAXES_COMPLETED = 'OnboardingFunnel_TaxesCompleted',
    ONBOARDING_FUNNEL_KIDS_COMPLETED = 'OnboardingFunnel_KidsCompleted',
}
